import './style.css';

function ListServices({items}){
    return <section className="list-services-container">
        {items.map(i => <img src={i}/>)}
    </section>
}

export default ListServices;